import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, signal, WritableSignal} from '@angular/core';
import {environment} from 'src/environments/environment.development';
import {Persona, Tipos} from "../interfaces/tipos";
import {CacheService} from "../../../shared/services/cache-service";
import { TipoCatalogo, TipoCategoriaProfesion, TipoCategoriaProfesionPorAmbito } from 'src/app/users/registro-profesionales/interfaces/tipos';
import { map } from 'rxjs';

const apiVucUrl = environment.apiVucUrl
@Injectable({providedIn: 'root'})
export class RegistroService {
    preregistroExito:WritableSignal<boolean> = signal(false)
    constructor(private http: HttpClient, private cacheService: CacheService) {
    }
    getTiposPersona(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/personas/tipos-persona?estado=${estado}`;
        return this.cacheService.memoize(url,this.http.get<Tipos[]>(url, {observe: 'response'}))
    }
    getTiposUsuario(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/personas/tipos-usuario?estado=${estado}`;
        return this.cacheService.memoize(url, this.http.get<Tipos[]>(url, {observe: 'response'}));
    }
    getTiposDocumento(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/personas/tipos-documento?estado=${estado}`;
        return this.cacheService.memoize(url, this.http.get<Tipos[]>(url, {observe: 'response'}));
    }
    getTiposContacto(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/personas/tipos-contacto?estado=${estado}`;
        return this.cacheService.memoize(url, this.http.get<Tipos[]>(url, {observe: 'response'}));
    }
    preregistrar(persona: Persona) {
        return this.http.post<Persona>(apiVucUrl + `api/v1.0/personas/preregistro`, persona, {observe: 'response'})
    }
    editarPerfil(persona: Persona) {
        return this.http.post<Persona>(`${apiVucUrl}api/v1.0/personas/editar-perfil`, persona, { observe: 'response' });
    }

    getTiposAmbito(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=AMB_REGIST&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<TipoCatalogo[]>(url, {observe: 'response'}));
    }
    getTiposNivelAcademico(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=NIVEL_ACAD&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<TipoCatalogo[]>(url, {observe: 'response'}));
    }
    getPaises(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=PAISES&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<TipoCatalogo[]>(url, {observe: 'response'}));
    }

    getTiposCategoriaProfesion(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=CLASI_PROF&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<Tipos[]>(url, {observe: 'response'}));
    }
    getTiposProfesion(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=PROFESION&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<Tipos[]>(url, {observe: 'response'}));
    }
    getTiposFlujo(estado: boolean = true) {
        let url = apiVucUrl + `api/v1.0/catalogos/tipo=FLUJO_TRAM&activo=${estado}`;
        return this.cacheService.memoize(url, this.http.get<TipoCatalogo[]>(url, {observe: 'response'}));
    }
    getTiposCategoriasConProfesiones(estado: boolean = true) {
        const url = apiVucUrl + `api/v1.0/clasificaciones-profesionales/clasificaciones`;
        return this.cacheService.memoize(
            url,
            this.http.get<{ clasificaciones: TipoCategoriaProfesion[] }>(url, { observe: 'response' }).pipe(
                map((resp) => ({
                    ...resp,
                    body: resp.body?.clasificaciones ?? [],
                }))
            )
        );
    }


getTiposCategoriasConProfesionesPorAmbito(estado: boolean = true) {
    // Asegúrate de que la URL se construye correctamente:
    const url = `${apiVucUrl}api/v1.0/clasificaciones-profesionales/ambitos/status/${estado}`;

    return this.cacheService.memoize(
        url,
        this.http.get<{ ambitos: TipoCategoriaProfesionPorAmbito[] }>(url, {
            observe: 'response',
            headers: {
                // Opcional: Agrega headers si el backend los requiere
                'User-Agent': navigator.userAgent
            }
        }).pipe(
            map(resp => ({
                ...resp,
                body: resp.body?.ambitos ?? [], // Manejo seguro de null/undefined
            })),


        )
    );
}



    getCatalogoPorCodigo(codigo: string) {
        let url = apiVucUrl + `api/v1.0/catalogos/codigoCatalogo=${codigo}`;
        return this.cacheService.memoize(url, this.http.get<TipoCatalogo>(url, {observe: 'response'}));
    }

}
